import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetMFAMethodsService } from '@modules/api/get-mfa-methods.service.generated';
import { MFADevice } from '@modules/api/mfa-device.generated';
import { SendLoginMFACodeService } from '@modules/api/send-login-mfa-code.service.generated';
import { CurrentLoginRequestService } from '@modules/login/services/current-login-request.service';

@Component({
    selector: 'app-login-select-mfa-method',
    templateUrl: './login-select-mfa-method.component.html',
    styleUrls: ['./login-select-mfa-method.component.scss']
})
export class LoginSelectMFAMethodComponent implements OnInit {
    public form!: FormGroup;
    public mfaDevices!: MFADevice[];
    public selectedMfaDeviceType!: string;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private getMFAMethodsService: GetMFAMethodsService,
        private sendLoginMFACodeService: SendLoginMFACodeService,
        private currentLoginRequestService: CurrentLoginRequestService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        let currentLoginRequest = this.currentLoginRequestService.getCurrentLoginRequest();

        this.getMFAMethodsService.getMFAMethods({
            loginRequestId: currentLoginRequest.id,
            loginRequestToken: currentLoginRequest.token
        }).subscribe(result => {
            this.mfaDevices = result.userContactMethods!.devices!;

            this.form = this.formBuilder.group({
                'userContactMethodRadio': ['', Validators.required],
                'rememberDevice': [{ value: '', disabled: result.shouldDisableRememberMeOption }]
            });
        });
    }

    public onSubmit(): void {
        if (this.form.valid) {
            let currentLoginRequest = this.currentLoginRequestService.getCurrentLoginRequest();
            this.sendLoginMFACodeService.sendLoginMFACode({
                loginRequestId: currentLoginRequest.id,
                loginRequestToken: currentLoginRequest.token,
                mfaDeviceType: this.form.get('userContactMethodRadio')!.value,
                rememberThisDevice: !!this.form.get('rememberDevice')!.value
            }).subscribe(result => {
                this.router.navigate(['../EnterMFACode', result.loginMFACodeId], { relativeTo: this.activatedRoute });
            });
        }
    }
}
